import { RouteHttpVerb } from "@devowl-wp/utils";
export var locationRestConsentGet = {
  path: "/consent",
  method: RouteHttpVerb.GET
};